// extracted by mini-css-extract-plugin
export default {"status":"NotFound_status__TR+ex","title":"NotFound_title__Jq+5w","message":"NotFound_message__QuTy8"};